<template>
	<DjBox class="">
		<h3 class="pt-5 md:pt-8 px-5 md:px-10 pb-5 md:pb-10 text-lg md:text-xl font-medium">{{ boxTitle }}</h3>
		<a
			class="block hover:text-dj-blue-dark active:text-dj-blue-dark transition-colors cursor-pointer break-words"
			:href="url"
			target="_blank"
		>
			<div class="px-10 pb-10">
				<span v-if="urlTitle">{{ urlTitle }}</span>
				<span v-else>{{ url }}</span>
			</div>
			<div v-if="imgUrl.length > 1" class="w-max h-max max-w-full rounded-b-2xl overflow-hidden">
				<img class="min-w-full" :src="imgUrl" alt="OG image" />
			</div>
		</a>
	</DjBox>
</template>

<script lang="ts">
import DjBox from "./DjBox.vue";

import { defineComponent, ref } from "vue";
import axios from "axios";
import { useI18n } from "vue-i18n";

export default defineComponent({
	name: "DjBoxArticle",
	components: {
		DjBox,
	},
	props: {
		boxTitle: {
			type: String,
			default: "",
			required: true,
		},
		url: {
			type: String,
			default: "",
			required: true,
		},
		urlTitle: {
			type: String,
			default: "",
			required: false,
		},
		apiUrl: {
			type: String,
			default: "",
			required: true,
		},
	},
	async setup(props) {
		const imgUrl = ref(false);

		axios({
			method: "post",
			url: `${props.apiUrl}/og-image-from-external-url`,
			data: { url: `${props.url}` },
		})
			.then((response) => {
				imgUrl.value = response.data.image;
			})
			.catch((error) => {
				let message = "Error fetching image from external URL";
				if (error.response?.status == 404) {
					console.error(error.code + ": " + message, {
						status: error.response?.status || "no status",
						url: error.response?.config?.url || "no url",
						userAgent: error.response?.config?.headers["User-Agent"] || "no user agent",
					});
				} else if (
					error.response?.status == 500 &&
					error.response?.data?.message?.includes("Could not resolve host:")
				) {
					console.error(error.code + ": " + message, {
						message: error.response?.data?.message ?? "no message",
						status: error.response?.status || "no status",
						url: error.response?.config?.url || "no url",
						userAgent: error.response?.config?.headers["User-Agent"] || "no user agent",
					});
				} else {
					console.error(message, error);
				}
			});

		return {
			imgUrl,
		};
	},
});
</script>
